import tickMarkImage from "../../images/newHome/Tick.svg";
import SectionTitle from "./SectionTitle";

const steps = [
    {
        day: "Day 1",
        title: "Make Booking",
        description: "Direct booking with selection of test items from www.testlabhub.com",
        className: "day-1",
    },
    {
        day: "Day 2",
        title: "Plan Review",
        description:
            "Activities including testing, documentation, filings, to meet go-to-market requirements",
        className: "day-2",
    },
    {
        day: "Day 3",
        title: "Start Project",
        description:
            "Project start @ test lab. Status viewable in WorkZone, Standard viewable in TechStreet",
        className: "day-3",
    },
];

function LabTestingSection() {
    return (
        <div className="container lg:p-[80px] py-6">
            <div className="flex flex-col items-center text-center">
                <SectionTitle
                    size="font-inter text-3xl sm:text-4xl lg:text-[44px]"
                    weight="font-semibold"
                    color="text-titleColor"
                >
                    Reserve Lab for Precertification Testing
                </SectionTitle>
                <p className="mt-[18px] text-base sm:text-lg text-textColor max-w-[990px]">
                    There's a 50% chance that products fail electromagnetic compatibility (EMC) tests the first time,
                    according to at least one leading industry expert. These realities make pre- certification testing
                    with the benefit of improved{" "}
                    <span className="font-medium text-primaryColor">read more</span>
                </p>
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-center lg:mt-[76px] mt-7 px-6 gap-8 relative">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`flex flex-col items-center text-center max-w-sm relative step-wrapper ${step.className}`}
                    >

                        {/* Icon */}
                        <div className="border border-dashed border-primaryColor rounded-full h-[74px] w-[74px] flex items-center justify-center">
                            <div className="bg-primaryColor h-[50px] w-[50px] rounded-full p-3">
                                <img src={tickMarkImage} alt="Tick" />
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="lg:px-4 mt-8">
                            <h6 className="text-primaryColor text-lg font-medium mb-4">{step.day}</h6>
                            <span className="block text-gray-700 text-base font-semibold">{step.title}</span>
                            <p className="text-gray-600 text-base font-normal mt-1">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default LabTestingSection;